jQuery( function($) {
	$(document).ready( function() {
        initSwiper();

        function initSwiper() {
            $('[data-product-list-slider]').each( function() {
                const swiperName = $(this).data('swiper-name');

                if ($(`#${swiperName}`).hasClass('swiper-initialized')) {
                    return;
                }

                let buttons = false;
                let scrollbar = false;
                let loop = true;
                let initialSlide = 0;


                if ($(this).hasClass('swiper-nav-buttons')) {
                    buttons = {
                        nextEl: `.${swiperName}-next`,
                        prevEl: `.${swiperName}-prev`,
                    };
                    scrollbar = {
                        el: `.${swiperName}-scrollbar`,
                        hide: false
                    }
                }

                if ($(this).hasClass('no-loop-swiper')) {
                    loop = false;

                    let totalSlides = $(this).find('.swiper-slide').length;

                    if (window.innerWidth > 640 && totalSlides > 2) {
                        initialSlide = 1;
                    }
                }

                new Swiper(`#${swiperName}`, {
                    slidesPerView: 'auto',
                    loop: loop,
                    initialSlide: initialSlide,
                    spaceBetween: 30,
                    centeredSlides: true,
                    scrollbar: scrollbar,
                    navigation: buttons,
                    preloadImages: false,
                    lazy: true,
                    watchSlidesProgress: true,
                });
            });
        }
	});
});
